/**
 * `<cart-count>` custom element (story 3.3, FR23 header).
 *
 * Reflects the current cart item count. Refreshes itself when a
 * `thcabina:cart-updated` event fires (dispatched after any cart mutation).
 */
class CartCount extends HTMLElement {
  connectedCallback() {
    document.addEventListener('thcabina:cart-updated', this.refresh.bind(this));
  }

  refresh() {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(`${root}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const count = cart.item_count || 0;
        this.textContent = String(count);
        this.hidden = count === 0;
      })
      .catch(() => {});
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount);
}
